import React, { FC } from "react";
import { useDialog } from "../components/dialog/DialogContext";
import TableTab from "../components/tabs/table-tab";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import TableContextStateMonitor from "../contexts/table/TableContextStateMonitor";
import { TranslationKeys } from "../contexts/TranslationKeys";
import EventTypeColumns from "../models/ColumnDefinitions/EventTypeColumns";
import { EventType } from "../models/EventType";
import { ListQuery } from "../models/ListQuery";
import EventTypeSearch from "../models/search/EventTypeSearch";
import { getEventTypeById, getEventTypes } from "../services/eventTypeService";
import { showLoadItemError } from "../services/utilities/ServiceError";

interface EventsTabProps {
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setEventType: React.Dispatch<React.SetStateAction<EventType>>;
    onFilterChange: (filters: any) => void;
}

const EventsTab: FC<EventsTabProps> = ({ setIsOpen, setEventType, onFilterChange }) => {
    const { translate } = useLocale();
    const dialog = useDialog();

    const onEditEventType = async (id: string) => {
        try {
            const eventType = await getEventTypeById(id, translate);
            setEventType(eventType)
            setIsOpen(true);
        } catch (error) {
            showLoadItemError(error, dialog, translate, () => { setIsOpen(false) });
        }
    }

    return <TableContextProvider
        key={"tbl_events"}
        dataMethod={(listParameters?: ListQuery) => getEventTypes(translate, listParameters)}
        tableDescriptor={EventTypeColumns}
        searchDescriptor={EventTypeSearch}
        useTable
        usePagination
        useFilter
        useSearch
        useSort
        editMethod={onEditEventType}>
        <TableContextStateMonitor onFilterChange={onFilterChange} />
        <TableTab
            title={translate.byKey(TranslationKeys.events)}
            selectRows={false}
            cyName="events"/>
    </TableContextProvider>
}

export default EventsTab;